// Тексты карты «как у Airbnb» (24.10.2026): полноэкранная карта на телефоне,
// «Искать в этой области», ♥ «Сохранённые», страница /tutors/saved.
// ЖДУТ УТВЕРЖДЕНИЯ владельца (таблица в теле PR). Отзывов и значков доверия
// здесь нет намеренно (решение владельца 06.10.2026).
import type { SiteLang } from "@/components/site/SiteChrome";

type UxCopy = {
  /** Ручка шторки списка (подпись для экранного диктора). */
  sheetHandle: string;
  save: string;
  unsave: string;
  savedLink: (n: number) => string;
  savedTitle: string;
  savedLeadLocal: string;
  savedLeadShared: string;
  savedEmpty: string;
  savedGone: string;
  sendWhatsApp: string;
  /** Первая строка сообщения WhatsApp, дальше — ссылка. */
  shareText: string;
  saveAllShared: string;
  backToMap: string;
  // Телефон «сначала карта» (25.10.2026): строка поиска, «Filtrlər», шторка, ссылка для репетиторов.
  searchPh: string;
  clearSearch: string;
  sugSubject: string;
  sugDistrict: string;
  sugMetro: string;
  filtersBtn: string;
  showN: (n: number) => string;
  /** Свёрнутая шторка: «N repetitor» / «N dərnək». */
  countOf: (layer: "tutor" | "club", n: number) => string;
  joinListLink: string;
};

/** Русское число: 1 репетитор, 2 репетитора, 5 репетиторов. */
const ruPlural = (n: number, one: string, few: string, many: string) => {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return `${n} ${one}`;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return `${n} ${few}`;
  return `${n} ${many}`;
};

export const MAP_UX: Record<SiteLang, UxCopy> = {
  az: {
    sheetHandle: "Siyahı",
    save: "Yadda saxla",
    unsave: "Saxlanılanlardan çıxar",
    savedLink: (n) => `Saxlanılanlar (${n})`,
    savedTitle: "Saxlanılan repetitorlar",
    savedLeadLocal: "Siyahı yalnız bu cihazda saxlanılır.",
    savedLeadShared: "Bu siyahını sizinlə paylaşıblar.",
    savedEmpty: "Hələ heç kim yoxdur. Kartda ♥ düyməsinə toxunun.",
    savedGone: "Bəzi anketlər artıq xəritədə yoxdur.",
    sendWhatsApp: "WhatsApp-a göndər",
    shareText: "Yolutap-da seçdiyim repetitorlar:",
    saveAllShared: "Hamısını yadda saxla",
    backToMap: "← Xəritəyə",
    searchPh: "Fənn, rayon və ya metro",
    clearSearch: "Təmizlə",
    sugSubject: "Fənn",
    sugDistrict: "Rayon",
    sugMetro: "Metro",
    filtersBtn: "Filtrlər",
    showN: (n) => `Göstər (${n})`,
    countOf: (layer, n) => (layer === "tutor" ? `${n} repetitor` : `${n} dərnək`),
    joinListLink: "Repetitorsunuz? Xəritəyə pulsuz əlavə olun →",
  },
  ru: {
    sheetHandle: "Список",
    save: "Сохранить",
    unsave: "Убрать из сохранённых",
    savedLink: (n) => `Сохранённые (${n})`,
    savedTitle: "Сохранённые репетиторы",
    savedLeadLocal: "Список хранится только на этом устройстве.",
    savedLeadShared: "Этим списком с вами поделились.",
    savedEmpty: "Пока никого нет. Нажмите ♥ на карточке.",
    savedGone: "Некоторых анкет уже нет на карте.",
    sendWhatsApp: "Отправить в WhatsApp",
    shareText: "Репетиторы, которых я выбрал(а) на Yolutap:",
    saveAllShared: "Сохранить всех себе",
    backToMap: "← К карте",
    searchPh: "Предмет, район, метро",
    clearSearch: "Очистить",
    sugSubject: "Предмет",
    sugDistrict: "Район",
    sugMetro: "Метро",
    filtersBtn: "Фильтры",
    showN: (n) => `Показать (${n})`,
    countOf: (layer, n) => (layer === "tutor" ? ruPlural(n, "репетитор", "репетитора", "репетиторов") : ruPlural(n, "кружок", "кружка", "кружков")),
    joinListLink: "Вы репетитор? Добавьтесь на карту бесплатно →",
  },
  en: {
    sheetHandle: "List",
    save: "Save",
    unsave: "Remove from saved",
    savedLink: (n) => `Saved (${n})`,
    savedTitle: "Saved tutors",
    savedLeadLocal: "This list is kept on this device only.",
    savedLeadShared: "Someone shared this list with you.",
    savedEmpty: "Nothing saved yet. Tap ♥ on a card.",
    savedGone: "Some profiles are no longer on the map.",
    sendWhatsApp: "Send to WhatsApp",
    shareText: "Tutors I picked on Yolutap:",
    saveAllShared: "Save all to my list",
    backToMap: "← Back to map",
    searchPh: "Subject, district, metro",
    clearSearch: "Clear",
    sugSubject: "Subject",
    sugDistrict: "District",
    sugMetro: "Metro",
    filtersBtn: "Filters",
    showN: (n) => `Show (${n})`,
    countOf: (layer, n) => (layer === "tutor" ? `${n} ${n === 1 ? "tutor" : "tutors"}` : `${n} ${n === 1 ? "club" : "clubs"}`),
    joinListLink: "Are you a tutor? Join the map for free →",
  },
};
